import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { UtilsService } from './service/utils.service';
import { SignInService } from './sign-in/sign-in.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  @ViewChild('sideNav', {static: true}) sideNav!: MatSidenav;

  constructor(
    private utils: UtilsService,
    private signInService: SignInService,

  ) {
  }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
  }
}
